module.exports = __webpack_public_path__ + "img/pen-square.bd05434f.svg";